module.exports = __webpack_public_path__ + "static/media/illustration_2.b222f494.jpg";